/* Pretty Walls — "See it on your wall"
   Everything runs in the visitor's browser: the wall photo is never uploaded.
   Cut-out: fast edge flood-fill for studio shots; AI background removal (@imgly) for anything else. */
(function () {
  'use strict';
  var root = document.querySelector('[data-wv]');
  if (!root) return;
  var $ = function (s, c) { return (c || root).querySelector(s); };
  var $$ = function (s, c) { return [].slice.call((c || root).querySelectorAll(s)); };

  var catalogue = [];
  try { catalogue = JSON.parse((document.querySelector('[data-wv-catalogue]') || {}).textContent || '[]'); } catch (e) { catalogue = []; }
  var WA = (root.dataset.wa || '').replace(/[^\d]/g, '');
  var AI_URL = root.dataset.ai || 'https://cdn.jsdelivr.net/npm/@imgly/background-removal@1.4.5/+esm';
  var AI_URL2 = 'https://esm.sh/@imgly/background-removal@1.4.5';

  var stage = $('[data-stage]'), empty = $('[data-empty]'), photo = $('[data-photo]'), art = $('[data-art]');
  var artCanvas = $('canvas', art), handle = $('[data-handle]', art), busy = $('[data-busy]'), busyText = $('[data-busy-text]');
  var tip = $('[data-tip]'), grid = $('[data-grid]'), search = $('[data-search]');
  var sizeR = $('[data-size]'), lightR = $('[data-light]'), shadowC = $('[data-shadow]'), wallIn = $('[data-wall]');
  var chosenEl = $('[data-chosen]'), realEl = $('[data-real]');
  var dlBtn = $('[data-download]'), shareBtn = $('[data-share]'), waBtn = $('[data-wa-send]'), viewBtn = $('[data-view]');

  var S = { photo: false, prod: null, cut: null, cx: .5, cy: .42, w: .34, aspect: 1, light: 1, auto: 1, shadow: true, filter: 'all', q: '' };
  var cache = {};
  var lumCanvas = null;

  /* ---------- helpers ---------- */
  function busyOn(t) { busyText.textContent = t || 'Preparing…'; busy.classList.add('is-on'); }
  function busyOff() { busy.classList.remove('is-on'); }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function photoRect() {
    var s = stage.getBoundingClientRect(), p = photo.getBoundingClientRect();
    return { x: p.left - s.left, y: p.top - s.top, w: p.width, h: p.height };
  }
  function loadImage(src) {
    return new Promise(function (res, rej) {
      var im = new Image(); im.crossOrigin = 'anonymous';
      im.onload = function () { res(im); }; im.onerror = rej; im.src = src;
    });
  }
  function sizeInches(p) {
    var d = p.d || '', m = d.match(/Size:\s*([\d.]+)\s*x\s*([\d.]+)\s*in/i), n = d.match(/Set of (\d+)/i), each = /in[^a-z]*\(?[^)]*\)?\s*each/i.test(d);
    var count = n ? +n[1] : 1, cols = Math.ceil(Math.sqrt(count));
    if (m) { var w = +m[1]; return each ? cols * w + (cols - 1) * 2 : w; }
    var r = d.match(/([\d.]+)\s*in[^a-z]*(round|cut-outs)/i);
    if (r) { var dia = +r[1]; return count > 1 ? cols * dia + (cols - 1) * 2 : dia; }
    return null;
  }

  /* ---------- cut-out ---------- */
  function cropAlpha(cv) {
    var c = cv.getContext('2d'), w = cv.width, h = cv.height, d = c.getImageData(0, 0, w, h).data;
    var x0 = w, y0 = h, x1 = 0, y1 = 0;
    for (var y = 0; y < h; y++) for (var x = 0; x < w; x++) if (d[(y * w + x) * 4 + 3] > 24) {
      if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y;
    }
    if (x1 <= x0 || y1 <= y0) return cv;
    var out = document.createElement('canvas'); out.width = x1 - x0 + 1; out.height = y1 - y0 + 1;
    out.getContext('2d').drawImage(cv, x0, y0, out.width, out.height, 0, 0, out.width, out.height);
    return out;
  }
  function floodCut(im) {
    var sc = Math.min(1, 1000 / Math.max(im.naturalWidth, im.naturalHeight));
    var w = Math.round(im.naturalWidth * sc), h = Math.round(im.naturalHeight * sc);
    var cv = document.createElement('canvas'); cv.width = w; cv.height = h;
    var c = cv.getContext('2d', { willReadFrequently: true }); c.drawImage(im, 0, 0, w, h);
    var img; try { img = c.getImageData(0, 0, w, h); } catch (e) { return null; }
    var d = img.data, N = w * h;
    var sr = 0, sg = 0, sb = 0, k = 0, pts = [];
    function addB(x, y) { var i = (y * w + x) * 4; pts.push([d[i], d[i + 1], d[i + 2]]); sr += d[i]; sg += d[i + 1]; sb += d[i + 2]; k++; }
    for (var x = 0; x < w; x += 3) { addB(x, 0); addB(x, h - 1); }
    for (var y = 0; y < h; y += 3) { addB(0, y); addB(w - 1, y); }
    var mr = sr / k, mg = sg / k, mb = sb / k, sd = 0;
    pts.forEach(function (p) { sd += Math.abs(p[0] - mr) + Math.abs(p[1] - mg) + Math.abs(p[2] - mb); });
    sd /= k * 3;
    if (sd > 16) return null;
    var mask = new Uint8Array(N), q = new Int32Array(N), qh = 0, qt = 0;
    function far(i) { var j = i * 4; return Math.abs(d[j] - mr) + Math.abs(d[j + 1] - mg) + Math.abs(d[j + 2] - mb); }
    function seed(i) { if (!mask[i] && far(i) < 90) { mask[i] = 1; q[qt++] = i; } }
    for (x = 0; x < w; x++) { seed(x); seed((h - 1) * w + x); }
    for (y = 0; y < h; y++) { seed(y * w); seed(y * w + w - 1); }
    while (qh < qt) {
      var p = q[qh++], px = p % w, py = (p / w) | 0, pj = p * 4;
      var nb = [px > 0 ? p - 1 : -1, px < w - 1 ? p + 1 : -1, py > 0 ? p - w : -1, py < h - 1 ? p + w : -1];
      for (var t = 0; t < 4; t++) {
        var n = nb[t]; if (n < 0 || mask[n]) continue;
        var nj = n * 4, step = Math.abs(d[nj] - d[pj]) + Math.abs(d[nj + 1] - d[pj + 1]) + Math.abs(d[nj + 2] - d[pj + 2]);
        if (step < 9 && far(n) < 110) { mask[n] = 1; q[qt++] = n; }
      }
    }
    var bg = 0; for (var i = 0; i < N; i++) bg += mask[i];
    var frac = bg / N; if (frac < .12 || frac > .96) return null;
    for (i = 0; i < N; i++) {
      if (mask[i]) { d[i * 4 + 3] = 0; continue; }
      var ix = i % w, iy = (i / w) | 0;
      if ((ix > 0 && mask[i - 1]) || (ix < w - 1 && mask[i + 1]) || (iy > 0 && mask[i - w]) || (iy < h - 1 && mask[i + w])) d[i * 4 + 3] = 150;
    }
    c.putImageData(img, 0, 0);
    return cropAlpha(cv);
  }
  var aiMod = null;
  function aiCut(src) {
    busyOn('Cutting out the piece with AI… first time takes a moment');
    var go = aiMod ? Promise.resolve(aiMod) : import(AI_URL).catch(function () { return import(AI_URL2); }).then(function (m) { aiMod = m; return m; });
    return go.then(function (m) {
      var fn = m.removeBackground || (m.default && m.default.removeBackground) || m.default;
      return fn(src, { model: 'isnet_quint8', output: { format: 'image/png' },
        progress: function (key, cur, tot) { if (tot) busyText.textContent = 'Loading AI model… ' + Math.round(cur / tot * 100) + '%'; } });
    }).then(function (blob) { return loadImage(URL.createObjectURL(blob)); })
      .then(function (im) { var cv = document.createElement('canvas'); cv.width = im.naturalWidth; cv.height = im.naturalHeight; cv.getContext('2d').drawImage(im, 0, 0); return cropAlpha(cv); });
  }
  function plain(im) { var cv = document.createElement('canvas'); cv.width = im.naturalWidth; cv.height = im.naturalHeight; cv.getContext('2d').drawImage(im, 0, 0); return cv; }
  function getCut(p) {
    if (cache[p.h]) return Promise.resolve(cache[p.h]);
    busyOn('Preparing ' + p.t + '…');
    return loadImage(p.i).then(function (im) {
      var cut = floodCut(im);
      if (cut) return cut;
      return aiCut(p.i).catch(function () { return plain(im); });
    }).then(function (cut) { cache[p.h] = cut; return cut; });
  }

  /* ---------- lighting ---------- */
  function buildLum() {
    lumCanvas = document.createElement('canvas');
    var sc = 320 / Math.max(photo.naturalWidth, photo.naturalHeight);
    lumCanvas.width = Math.max(1, Math.round(photo.naturalWidth * sc)); lumCanvas.height = Math.max(1, Math.round(photo.naturalHeight * sc));
    lumCanvas.getContext('2d', { willReadFrequently: true }).drawImage(photo, 0, 0, lumCanvas.width, lumCanvas.height);
  }
  function autoLight() {
    if (!lumCanvas) return 1;
    var W = lumCanvas.width, H = lumCanvas.height, hw = S.w * W / 2, hh = S.w * S.aspect * W / 2;
    var x = clamp(Math.round(S.cx * W - hw * 1.3), 0, W - 1), y = clamp(Math.round(S.cy * H - hh * 1.3), 0, H - 1);
    var x2 = clamp(Math.round(S.cx * W + hw * 1.3), x + 1, W), y2 = clamp(Math.round(S.cy * H + hh * 1.3), y + 1, H);
    var d = lumCanvas.getContext('2d').getImageData(x, y, x2 - x, y2 - y).data, s = 0, n = 0;
    for (var i = 0; i < d.length; i += 16) { s += (0.2126 * d[i] + 0.7152 * d[i + 1] + 0.0722 * d[i + 2]) / 255; n++; }
    var L = n ? s / n : .6;
    return clamp(0.5 + L * 0.65, 0.62, 1.1);
  }

  /* ---------- render ---------- */
  function render() {
    if (!S.photo || !S.cut) { art.hidden = true; return; }
    var r = photoRect(), wpx = S.w * r.w, hpx = wpx * S.aspect;
    art.hidden = false;
    art.style.width = wpx + 'px'; art.style.height = hpx + 'px';
    art.style.left = (r.x + S.cx * r.w - wpx / 2) + 'px'; art.style.top = (r.y + S.cy * r.h - hpx / 2) + 'px';
    var k = (S.auto * S.light).toFixed(3), o = Math.max(2, wpx * .02);
    artCanvas.style.filter = 'brightness(' + k + ')' + (S.shadow ? ' drop-shadow(' + o.toFixed(1) + 'px ' + (o * 1.5).toFixed(1) + 'px ' + (o * 1.8).toFixed(1) + 'px rgba(0,0,0,.38))' : '');
    sizeR.value = Math.round(S.w * 100);
    var ft = parseFloat(wallIn.value), inch = S.prod && sizeInches(S.prod);
    if (ft > 0) {
      var wIn = S.w * ft * 12;
      realEl.textContent = 'Shown about ' + Math.round(wIn) + ' in (' + Math.round(wIn * 2.54) + ' cm) wide on your ' + ft + ' ft wall' + (inch ? ' · actual piece ≈ ' + Math.round(inch) + ' in' : '');
    } else realEl.textContent = 'Tip: enter your wall width to see the piece at its true size.';
  }
  function setCut(cut) {
    S.cut = cut; S.aspect = cut.height / cut.width;
    artCanvas.width = cut.width; artCanvas.height = cut.height;
    artCanvas.getContext('2d').clearRect(0, 0, cut.width, cut.height);
    artCanvas.getContext('2d').drawImage(cut, 0, 0);
  }
  function trueScale() {
    var ft = parseFloat(wallIn.value), inch = S.prod && sizeInches(S.prod);
    if (ft > 0 && inch) S.w = clamp(inch / (ft * 12), .03, .98);
  }
  function choose(p) {
    S.prod = p;
    $$('[data-pick]', grid).forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.pick === p.h ? 'true' : 'false'); });
    chosenEl.innerHTML = ''; chosenEl.appendChild(document.createTextNode(p.t));
    var sm = document.createElement('small'); var inch = sizeInches(p); sm.textContent = inch ? 'About ' + Math.round(inch) + ' in (' + Math.round(inch * 2.54) + ' cm) wide' : 'Size made to order';
    chosenEl.appendChild(sm);
    viewBtn.href = p.u; viewBtn.removeAttribute('aria-disabled');
    updateWA();
    getCut(p).then(function (cut) {
      if (S.prod !== p) return;
      setCut(cut); S.w = .34; trueScale();
      S.cy = S.aspect > 1.2 ? .44 : .4; S.cx = .5;
      S.auto = autoLight(); busyOff(); render(); enable(); hint('Drag to move · use the corner or slider to resize');
    }).catch(function () { busyOff(); alert('Sorry, that piece could not be loaded. Please try another.'); });
  }
  function enable() { var on = S.photo && S.cut; [dlBtn, shareBtn].forEach(function (b) { if (b) b.disabled = !on; }); }
  function hint(t) { if (!tip) return; tip.textContent = t; tip.style.opacity = 1; clearTimeout(hint.t); hint.t = setTimeout(function () { tip.style.opacity = 0; }, 3800); }
  function updateWA() {
    if (!waBtn) return;
    var msg = 'Hi Pretty Walls! I tried ' + (S.prod ? S.prod.t : 'your wall art') + ' on my wall with the visualiser and would love a quote.' + (S.prod ? ' ' + location.origin + S.prod.u : '') + ' (Attaching my wall photo.)';
    waBtn.href = 'https://wa.me/' + WA + '?text=' + encodeURIComponent(msg);
  }

  /* ---------- catalogue ---------- */
  function drawGrid() {
    grid.innerHTML = '';
    var q = S.q.trim().toLowerCase();
    catalogue.filter(function (p) {
      return (S.filter === 'all' || (p.tags || []).indexOf(S.filter) > -1) && (!q || p.t.toLowerCase().indexOf(q) > -1);
    }).forEach(function (p) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'wv__pick'; b.dataset.pick = p.h;
      b.setAttribute('aria-pressed', S.prod && S.prod.h === p.h ? 'true' : 'false');
      var im = document.createElement('img'); im.src = p.th; im.alt = ''; im.loading = 'lazy';
      var s = document.createElement('span'); s.textContent = p.t;
      b.appendChild(im); b.appendChild(s);
      b.addEventListener('click', function () {
        if (!S.photo) { pendingPick = p; markPending(p); hint('Now add a photo of your wall'); flashEmpty(); return; }
        choose(p);
      });
      grid.appendChild(b);
    });
    if (!grid.children.length) { var e = document.createElement('p'); e.className = 'wv__note'; e.textContent = 'No pieces match.'; grid.appendChild(e); }
  }
  var pendingPick = null;
  function markPending(p) { $$('[data-pick]', grid).forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.pick === p.h ? 'true' : 'false'); }); }
  function flashEmpty() { empty.animate && empty.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.03)' }, { transform: 'scale(1)' }], { duration: 500 }); }
  $$('[data-chip]').forEach(function (c) {
    c.addEventListener('click', function () {
      S.filter = c.dataset.chip; $$('[data-chip]').forEach(function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); }); drawGrid();
    });
  });
  search.addEventListener('input', function () { S.q = search.value; drawGrid(); });

  /* ---------- wall photo ---------- */
  function usePhoto(src) {
    busyOn('Loading your wall…');
    photo.onload = function () {
      S.photo = true; empty.hidden = true; photo.hidden = false; buildLum(); busyOff();
      $$('[data-change]').forEach(function (b) { b.hidden = false; });
      var p = S.prod || pendingPick || catalogue[0];
      if (p) { if (S.cut && S.prod === p) { S.auto = autoLight(); render(); } else choose(p); }
    };
    photo.src = src;
  }
  $$('[data-file]').forEach(function (inp) {
    inp.addEventListener('change', function () { var f = inp.files && inp.files[0]; if (f) usePhoto(URL.createObjectURL(f)); inp.value = ''; });
  });
  $$('[data-sample]').forEach(function (b) { b.addEventListener('click', function () { usePhoto(b.dataset.sample); }); });
  stage.addEventListener('dragover', function (e) { e.preventDefault(); });
  stage.addEventListener('drop', function (e) { e.preventDefault(); var f = e.dataTransfer.files[0]; if (f && /^image\//.test(f.type)) usePhoto(URL.createObjectURL(f)); });

  /* ---------- move / resize ---------- */
  var ptrs = {}, mode = null, start = null;
  function toNorm(dx, dy) { var r = photoRect(); return { x: dx / r.w, y: dy / r.h }; }
  art.addEventListener('pointerdown', function (e) {
    e.preventDefault(); art.setPointerCapture(e.pointerId); ptrs[e.pointerId] = { x: e.clientX, y: e.clientY };
    var n = Object.keys(ptrs).length;
    if (n === 2) { var a = Object.values(ptrs); mode = 'pinch'; start = { d: Math.hypot(a[0].x - a[1].x, a[0].y - a[1].y), w: S.w }; return; }
    mode = e.target === handle ? 'resize' : 'drag'; art.classList.add('is-drag');
    start = { x: e.clientX, y: e.clientY, cx: S.cx, cy: S.cy, w: S.w };
  });
  art.addEventListener('pointermove', function (e) {
    if (!ptrs[e.pointerId]) return; ptrs[e.pointerId] = { x: e.clientX, y: e.clientY };
    if (mode === 'pinch') { var a = Object.values(ptrs); if (a.length < 2) return; var d = Math.hypot(a[0].x - a[1].x, a[0].y - a[1].y); S.w = clamp(start.w * d / start.d, .03, .98); render(); return; }
    var dn = toNorm(e.clientX - start.x, e.clientY - start.y);
    if (mode === 'drag') { S.cx = clamp(start.cx + dn.x, 0, 1); S.cy = clamp(start.cy + dn.y, 0, 1); }
    else if (mode === 'resize') { S.w = clamp(start.w + dn.x * 2, .03, .98); }
    render();
  });
  function up(e) { delete ptrs[e.pointerId]; if (!Object.keys(ptrs).length) { mode = null; art.classList.remove('is-drag'); if (S.cut) { S.auto = autoLight(); render(); } } }
  art.addEventListener('pointerup', up); art.addEventListener('pointercancel', up);
  stage.addEventListener('wheel', function (e) { if (!S.cut) return; e.preventDefault(); S.w = clamp(S.w * (e.deltaY < 0 ? 1.05 : .95), .03, .98); render(); }, { passive: false });
  art.addEventListener('keydown', function (e) {
    var st = e.shiftKey ? .05 : .01, h = true;
    if (e.key === 'ArrowLeft') S.cx -= st; else if (e.key === 'ArrowRight') S.cx += st; else if (e.key === 'ArrowUp') S.cy -= st; else if (e.key === 'ArrowDown') S.cy += st;
    else if (e.key === '+' || e.key === '=') S.w *= 1.05; else if (e.key === '-') S.w *= .95; else h = false;
    if (h) { e.preventDefault(); S.cx = clamp(S.cx, 0, 1); S.cy = clamp(S.cy, 0, 1); S.w = clamp(S.w, .03, .98); render(); }
  });
  sizeR.addEventListener('input', function () { S.w = clamp(sizeR.value / 100, .03, .98); render(); });
  lightR.addEventListener('input', function () { S.light = lightR.value / 100; render(); });
  shadowC.addEventListener('change', function () { S.shadow = shadowC.checked; render(); });
  wallIn.addEventListener('input', function () { trueScale(); render(); });
  window.addEventListener('resize', render);

  /* ---------- export ---------- */
  function composite() {
    var sc = Math.min(1, 2400 / Math.max(photo.naturalWidth, photo.naturalHeight));
    var W = Math.round(photo.naturalWidth * sc), H = Math.round(photo.naturalHeight * sc);
    var cv = document.createElement('canvas'); cv.width = W; cv.height = H;
    var c = cv.getContext('2d'); c.drawImage(photo, 0, 0, W, H);
    var aw = S.w * W, ah = aw * S.aspect, ax = S.cx * W - aw / 2, ay = S.cy * H - ah / 2;
    c.save();
    if (S.shadow) { var o = Math.max(2, aw * .02); c.shadowColor = 'rgba(0,0,0,.38)'; c.shadowBlur = o * 1.8; c.shadowOffsetX = o; c.shadowOffsetY = o * 1.5; }
    if ('filter' in c) c.filter = 'brightness(' + (S.auto * S.light).toFixed(3) + ')';
    c.drawImage(S.cut, ax, ay, aw, ah); c.restore();
    var fs = Math.max(14, Math.round(W * .018));
    c.font = '500 ' + fs + 'px "Albert Sans", sans-serif'; c.textAlign = 'right'; c.textBaseline = 'bottom';
    c.fillStyle = 'rgba(0,0,0,.35)'; c.fillText('Pretty Walls · ' + (S.prod ? S.prod.t : '') + ' · prettywalls.in', W - fs + 1, H - fs * .8 + 1);
    c.fillStyle = 'rgba(255,255,255,.92)'; c.fillText('Pretty Walls · ' + (S.prod ? S.prod.t : '') + ' · prettywalls.in', W - fs, H - fs * .8);
    return cv;
  }
  function fileName() { return 'pretty-walls-' + (S.prod ? S.prod.h : 'wall') + '-on-my-wall.jpg'; }
  dlBtn.addEventListener('click', function () {
    composite().toBlob(function (b) {
      var a = document.createElement('a'); a.href = URL.createObjectURL(b); a.download = fileName(); document.body.appendChild(a); a.click(); a.remove();
    }, 'image/jpeg', .92);
  });
  if (shareBtn) {
    var canFiles = !!(navigator.canShare && window.File);
    if (!canFiles) shareBtn.hidden = true;
    shareBtn.addEventListener('click', function () {
      composite().toBlob(function (b) {
        var f = new File([b], fileName(), { type: 'image/jpeg' });
        var data = { files: [f], title: 'Pretty Walls on my wall', text: 'Hi Pretty Walls! Here is ' + (S.prod ? S.prod.t : 'your piece') + ' on my wall — please share a quote.' };
        if (navigator.canShare(data)) navigator.share(data).catch(function () {}); else dlBtn.click();
      }, 'image/jpeg', .92);
    });
  }

  /* ---------- start ---------- */
  drawGrid(); updateWA(); enable();
  var want = new URLSearchParams(location.search).get('product');
  if (want) { var p = catalogue.filter(function (x) { return x.h === want; })[0]; if (p) { pendingPick = p; markPending(p); var g = $('[data-pick="' + want + '"]', grid); if (g) g.scrollIntoView({ block: 'nearest' }); } }
})();
